export const lightBodyStyle =
  "bg-gradient-to-b from-white to-red-100 text-black";

export const darkBodyStyle =
  "bg-gradient-to-b from-gray-800 to-slate-900 text-white";

export const desktopBlockStyle = "p-20 w-full h-[80vh]";

export const buttonLightStyle =
  "rounded-2xl px-4 py-0.5 hover:bg-wine hover:text-white text-lg";

export const statisticsPointStyle = "flex md:pt-4 xl:pt-8 items-center gap-8";

export const mobileStatisticsPointStyle = "flex pt-3 items-center gap-4";

export const questionsStyle = "flex flex-col items-center pt-14 gap-16";

export const mobileQuestionStyle = "flex flex-col items-center pt-4 gap-6";
